import BlocksGrid from '../../components/cities/BlocksGrid';
import PageSeo from '../../components/PageSeo';

export default function BlocksPage() {
  return (
    <>
      <PageSeo
        title={`Shitty City Blocks`}
        description='Collect Shitty City Blocks to add to your Shitty Cities. Each Shitty City is constructed of up to 9 Shitty City Blocks. Using ARC19, your Shitty City is completely customizable.'
      />
      <div className='px-4 lg:px-8 mb-12'>
        <BlocksGrid />
      </div>
    </>
  );
}
